import {makeAutoObservable} from 'mobx';
import {TitleSummaryRequest} from '../../entity/model/title-summary-request';
import {RequestBody} from '../../entity/core/request-body';
import TitleSummaryRequestAgent from '../agent/title-summary-request-agent';
import {TitleSummaryReportProps} from '../../entity/props/title/title-summary-report-props';

export default class TitleSummaryRequestStore {
    private _currentProps: TitleSummaryReportProps | undefined = undefined;
    private readonly SHARED_DATA_KEY = 'titleSummaryReportSharedData';
    titleSummaryRequestAgent: TitleSummaryRequestAgent;
    titleSummaryRequests: TitleSummaryRequest[] = [];

    constructor(titleSummaryRequestAgent: TitleSummaryRequestAgent) {
        makeAutoObservable(this);
        this.titleSummaryRequestAgent = titleSummaryRequestAgent;
    }

    get currentProps(): TitleSummaryReportProps | undefined {
        return this._currentProps;
    }

    setCurrentProps = (props: TitleSummaryReportProps | undefined): void => {
        this._currentProps = props;
        if (props) 
            this.setSharedData(props);
    }

    clearCurrentProps = (): void => {
        this._currentProps = undefined;
    }

    setSharedData = (props: TitleSummaryReportProps): void => {
        localStorage.setItem(this.SHARED_DATA_KEY, JSON.stringify(props));
    }

    getSharedData = (): TitleSummaryReportProps | undefined => {
        const data = localStorage.getItem(this.SHARED_DATA_KEY);
        if (data) 
            return JSON.parse(data);

        return undefined;
    }

    clearSharedData = (): void => {
        localStorage.removeItem(this.SHARED_DATA_KEY);
    }

    loadSharedData = (): void => {
        const sharedData = this.getSharedData();
        if (sharedData) {
            this._currentProps = sharedData;
            this.clearSharedData();
        }
    }

    loadTitleSummaryRequests = async (organizationId: string, titleId: string): Promise<void> => {
        try {
            this.titleSummaryRequests = await this.titleSummaryRequestAgent.getTitleSummaryRequests(organizationId, titleId);
        } catch (error: any) {
            console.error('Error occurred while fetching the title summary requests', error);
        }
    }

    createTitleSummaryRequest = async (organizationId: string, requestBody: RequestBody): Promise<TitleSummaryRequest | string> => {
        try {
            return await this.titleSummaryRequestAgent.createTitleSummaryRequest(organizationId, requestBody);
        } catch (error: any) {
            console.error('Error occurred while creating title summary request', error);
            return 'Error occurred while creating title summary request !!';
        }
    }

    updateTitleSummaryRequest = async (organizationId: string, titleSummaryRequestId: string, requestBody: RequestBody): Promise<TitleSummaryRequest | string> => {
        try {
            return await this.titleSummaryRequestAgent.updateTitleSummaryRequest(organizationId, titleSummaryRequestId, requestBody);
        } catch (error: any) {
            console.error('Error occurred while updating title summary request', error);
            return 'Error occurred while updating title summary request !!';
        }
    }
} 